import React, { memo } from 'react';
import { cn } from '@/utils';

const akiniIconSrc = `${process.env.PUBLIC_URL ?? ''}/brand/akini-icon.png`;

/** Brand mark (Akini). Kept path `Rapida.tsx` for minimal import churn. */
export const RapidaIcon = memo(
  (props: React.ImgHTMLAttributes<HTMLImageElement>) => {
    const { className, alt = 'Akini Voice', ...rest } = props;
    return (
      <img
        src={akiniIconSrc}
        alt={alt}
        className={cn('w-5 h-5 object-contain shrink-0', className)}
        {...rest}
      />
    );
  },
);
